'use client'
import React, { useState } from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import YoutubePreview from '@components/YoutubePreview'
import VideoGallery from '@components/VideoGallery'
import { IoMdPhotos } from 'react-icons/io'
import dynamic from 'next/dynamic';
const Gallery = dynamic(() => import('@components/Gallery'), {
    ssr: false,
});

// Import Swiper styles
import "swiper/css";
import 'swiper/css/navigation';

const PropertyGallery = ({ gallery, videoUrl, promotionTitle = undefined, altName = '', isMobile = false }) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [isVideoPopupOpen, setVideoPopupOpen] = useState(false);

    const openPopup = (index) => {
        if (gallery && gallery.length > 0) {
            setActiveSlide(index)
            setPopupOpen(true);
            setVideoPopupOpen(false);
        }
    };

    const openVideoPopup = () => {
        setVideoPopupOpen(true);
        setPopupOpen(false);
    };

    const closePopup = () => {
        setPopupOpen(false);
    };

    const closeVideoPopup = () => {
        setVideoPopupOpen(false);
    };

    if (isMobile) return (
        <>
            {videoUrl ? (
                <div className='block sm:hidden' onMouseEnter={() => import('@components/Gallery')}>
                    <Swiper
                        className="mySwiper"
                    >
                        {gallery && gallery.map((image, index) => (
                            <SwiperSlide key={index} className="relative">
                                <div className='w-full max-h-[270px] relative overflow-hidden'>
                                    <Image
                                        onClick={openPopup}
                                        src={image}
                                        alt={`${altName} Image ${index + 1}`}
                                        width={1000}
                                        height={667}
                                        priority={index === 0}
                                        loading={index === 0 ? "eager" : "lazy"}
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAYAAACqNX6+AAAAXUlEQVR42u3RMQEAAAgDoJnc6FrB0wMqUMl0eKOECEGIEIQIQYgQhAgRIgQhQhAiBCFCECIEIQgRghAhCBGCECEIQYgQhAhBiBCECEEIQoQgRAhChCBECEIQIoSrBfgKSs//8LAxAAAAAElFTkSuQmCC"
                                    />
                                </div>
                                <div className="absolute z-10 bottom-2 right-2 flex flex-row items-center bg-maincolortrans rounded-md text-light p-1">
                                    <span>{index + 1}/{gallery.length}</span>
                                    <IoMdPhotos
                                        className="ml-1"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            ):(
                <div className='block sm:hidden' onMouseEnter={() => import('@components/Gallery')}>
                    <Swiper
                        className="mySwiper"
                    >
                        {videoUrl && (
                            <SwiperSlide key={'video'} className="relative w-full">
                                <div className='w-full max-h-[270px] relative overflow-hidden video-slide'>
                                    <YoutubePreview className='z-20' url={videoUrl} height={"270"} width={"420"} />
                                </div>
                            </SwiperSlide>
                        )

                        }
                        {gallery && gallery.map((image, index) => (
                            <SwiperSlide key={index} className="relative">
                                <div className='relative w-full aspect-[4/3] overflow-hidden'>
                                    {promotionTitle && (
                                        <div className='absolute left-2 top-2 bg-third text-light p-1 rounded-md z-10 font-semibold'>{promotionTitle}</div>
                                    )}
                                    <Image
                                        onClick={openPopup}
                                        src={image}
                                        alt={`${altName} Image ${index + 1}`}
                                        width={1000}
                                        height={667}
                                        priority={index == 0}
                                        placeholder="blur"
                                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyCAYAAACqNX6+AAAAXUlEQVR42u3RMQEAAAgDoJnc6FrB0wMqUMl0eKOECEGIEIQIQYgQhAgRIgQhQhAiBCFCECIEIQgRghAhCBGCECEIQYgQhAhBiBCECEEIQoQgRAhChCBECEIQIoSrBfgKSs//8LAxAAAAAElFTkSuQmCC"
                                    />
                                </div>
                                <div className="absolute z-10 bottom-2 right-2 flex flex-row items-center bg-maincolortrans rounded-md text-light p-1">
                                    <span>{index + 1}/{gallery.length}</span>
                                    <IoMdPhotos
                                        className="ml-1"
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )}
            {openPopup && (
                <Gallery isOpen={isPopupOpen} onClose={closePopup} gallery={gallery} videoUrl={videoUrl} initialSlide={activeSlide} altName={altName} />
            )}
            <VideoGallery isVideoOpen={isVideoPopupOpen} onVideoClose={closeVideoPopup} videoUrl={videoUrl} />
        </>
    )

    return (
        <>
            {videoUrl ? (
                <div className='hidden sm:flex w-full flex-row' onMouseEnter={() => import('@components/Gallery')}>
                    <div className='w-1/2 py-1 pr-1'>
                        <div className='relative w-full aspect-[4/3] rounded-md overflow-hidden bg-maincolor hover:shadow-md'>
                            <div className='w-full h-full relative flex justify-center items-center overflow-hidden'>
                                <YoutubePreview className='z-20' url={videoUrl}   />
                            </div>
                        </div>
                    </div>
                    <div className='w-1/2 flex flex-wrap'>
                        {gallery.map((value, index) => {
                            if (index >= 0 && index <= 3) {
                                return (
                                    <div className='w-1/2 p-1' key={index}>
                                        <div className='relative w-full aspect-[4/3] rounded-md overflow-hidden hover:border-[2px] hover:shadow-md  duration-150'>
                                            <Image
                                                onClick={() => openPopup(index)}
                                                className='object-cover cursor-pointer hover:shadow-xl'
                                                src={gallery[index]}
                                                fill={true}
                                                alt={`${altName} Image ${index + 1}`}
                                                loading="lazy"
                                            />
                                        {index == 4 && (
                                            <div 
                                                className='group absolute overflow-hidden rounded-md z-40 top-0 left-0 bottom-0 right-0 flex justify-center items-center bg-black bg-opacity-30 hover:bg-opacity-0 duration-150 cursor-pointer'
                                                onClick={() => openPopup(0)}
                                            >
                                                <span className='z-50 text-xl text-light font-semibold group-hover:underline group-hover:underline-offset-4'>{gallery.length} Photos</span>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                )
                            }
                            })}
                    </div>
                </div>
            ):(
                <div className='hidden sm:flex w-full flex-row' onMouseEnter={() => import('@components/Gallery')}>
                    <div className='w-1/2 py-1 pr-1'>
                        <div className='relative w-full aspect-[4/3] rounded-md overflow-hidden hover:border-[2px] hover:shadow-md  duration-150'>
                            {promotionTitle && (
                                <div className='absolute left-2 top-2 bg-third text-light p-1 rounded-md z-10 font-semibold'>{promotionTitle}</div>
                            )}
                            <Image
                                onClick={() => openPopup(0)}
                                className='object-cover cursor-pointer'
                                src={gallery[0] !== undefined ? gallery[0] : '/images/test.jpg'}
                                fill={true}
                                alt={`${altName} Image 1`}
                                priority={true}
                            />
                        </div>
                    </div>
                    <div className='w-1/2 flex flex-wrap'>
                        {gallery.map((value, index) => {
                            if (index >= 1 && index <= 4) {
                                return (
                                    <div className='w-1/2 p-1' key={index}>
                                        <div className='relative w-full aspect-[4/3] rounded-md overflow-hidden hover:border-[2px] hover:shadow-md  duration-150'>
                                            <Image
                                                onClick={() => openPopup(index)}
                                                className='object-cover cursor-pointer hover:shadow-xl'
                                                src={gallery[index]}
                                                fill={true}
                                                alt={`${altName} Image ${index + 2}`}
                                                priority
                                            />
                                        {index == 4 && (
                                            <div 
                                                className='group absolute overflow-hidden rounded-md z-40 top-0 left-0 bottom-0 right-0 flex justify-center items-center bg-black bg-opacity-30 hover:bg-opacity-0 duration-150 cursor-pointer'
                                                onClick={() => openPopup(0)}
                                            >
                                                <span className='z-50 text-xl text-light font-semibold group-hover:underline group-hover:underline-offset-4'>{gallery.length} Photos</span>
                                            </div>
                                        )}
                                        </div>
                                    </div>
                                )
                            }
                            })}
                    </div>
                </div>
            )}
             {openPopup && (
                <Gallery isOpen={isPopupOpen} onClose={closePopup} gallery={gallery} videoUrl={videoUrl} initialSlide={activeSlide} altName={altName} />
            )}
            <VideoGallery isVideoOpen={isVideoPopupOpen} onVideoClose={closeVideoPopup} videoUrl={videoUrl} />
        </>
    )
}

export default PropertyGallery